var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.addresses),function(address){return _c('div',[_c('div',[_vm._v(_vm._s(address.postCode))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }